import { render, staticRenderFns } from "./TransitionScreen.vue?vue&type=template&id=6c7cedfa&scoped=true"
import script from "./TransitionScreen.vue?vue&type=script&lang=js"
export * from "./TransitionScreen.vue?vue&type=script&lang=js"
import style0 from "./TransitionScreen.vue?vue&type=style&index=0&id=6c7cedfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7cedfa",
  null
  
)

export default component.exports